<div class="employee-short-info">
  <base-avatar
    class="me-3"
    [image]="anonymous ? '' : avatar"
    [size]="baseAvatarSize.medium"
  ></base-avatar>
  <div class="d-flex flex-column max-w-150px fw-bold">
    <p
      baseTruncate
      class="m-0"
    >
      {{ lastName }},
    </p>
    <p
      baseTruncate
      class="m-0"
    >
      {{ firstName }}
    </p>
  </div>
</div>
